import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import jwt from 'jsonwebtoken';
import NotFound from '../pages/NotFound/NotFound';
import { getUser } from '../actions/users/co-user-actions';
import Loader from '../components/Loader';
import Dashboard from '../pages/Dashboard';
import { getSubscription } from '../actions/subscription/subscription-actions';
import { getToggleSettings } from '../actions/settings/settings';
import { checkInSubscription, getUserRoleId } from '../components/Utils/helper';
import { getUnreadMsgsCount } from '../actions/communication/communication-action';
// import socket from '../utils/socket';

export default function RouteWrapper({
  component: Component,
  type,
  stripeStatus,
  isPrivate,
  verifiable,
  notFound,
  underConstruction,
  isAuth,
  path,
  location,
  name,
  allowBoth,
  ...rest
}) {
  let signed = false;
  const parameterised = false;
  const user = JSON.parse(localStorage.getItem('userData'));

  const dispatch = useDispatch();

  const { getToggleSettingsLoading = false, toggleSettings = '' } = useSelector(
    (state) => state?.settings,
  );

  const { userData: { permissions = '' } = '' } =
    useSelector((state) => state.coUser) || '';

  const { subscription = '', trialInfo = '' } = useSelector(
    (s) => s.subscription,
  );

  let jwttoken;
  let jwtDecodeToken;
  if (user) {
    const { token } = user;
    jwttoken = token;
  }

  if (jwttoken) {
    jwtDecodeToken = jwt.decode(jwttoken);
  }

  if (jwtDecodeToken) {
    if (jwtDecodeToken.exp < Date.now() / 1000) {
      const history = useHistory();
      localStorage.removeItem('userData');
      history.push('/signin');
    }

    if (name && permissions && jwtDecodeToken.roleId !== 4) {
      notFound = !permissions?.some(
        (resource) => resource.name === name && resource.value === true,
      );
    }
    if (!parameterised) signed = true;
  }

  useEffect(() => {
    if (!user?.userStore) return; // call api's only if user store exists

    if (!permissions && isPrivate && name && jwtDecodeToken?.roleId !== 4) {
      dispatch(getUser());
    }
    if (Object.keys(subscription || '').length === 0 && isPrivate && name) {
      dispatch(getSubscription());
    }
    if (getUserRoleId() === 4 && Object.keys(toggleSettings)?.length === 0) {
      dispatch(getToggleSettings());
    }
    dispatch(getUnreadMsgsCount()); // unread msgs count
  }, [path]);

  useEffect(() => {
    if (!user?.userStore) return; // call api's only if user store exists

    dispatch(getUnreadMsgsCount()); // unread msgs count
  }, []);

  if (
    ((!user?.userStore && jwtDecodeToken) ||
      (trialInfo?.status &&
        !(
          trialInfo?.status === 'trialing' || trialInfo?.status === 'active'
        ))) &&
    !user?.verified // just for co-user verification case
  ) {
    return (
      <>
        <Redirect to='/dashboard' />
        <Route
          path='/dashboard'
          name='dashboard'
          isPrivate
          exact
          component={Dashboard}
        />
      </>
    );
  }
  // if work in progress toggle off from settings then dont show jobboard for only owner
  if (!getToggleSettingsLoading && Object.keys(subscription || '').length) {
    if (
      !toggleSettings.workInProgress &&
      name === 'jobboard' &&
      jwtDecodeToken?.roleId === 4
    ) {
      notFound = true;
    }
  }

  if (notFound) {
    return <NotFound notFound />;
  }

  if (underConstruction) {
    return <NotFound />;
  }

  /**
   * Redirect user to Main page if he tries to access a non private route
   * (SignIn or SignUp) after being authenticated.
   */
  if (!isPrivate && signed && !verifiable) {
    if (!allowBoth) {
      return <Redirect to='/dashboard' />;
    }
  }

  /**
   * Redirect user to SignIn page if he tries to access a private route
   * without authentication.
   */
  if (isPrivate && !signed) {
    return <Redirect to='/signin' />;
  }

  if (path === '/') {
    return <Redirect to='/dashboard' />;
  }
  if (
    (Object.keys(subscription || '').length === 0 &&
      signed &&
      isPrivate &&
      name) ||
    (!permissions &&
      signed &&
      isPrivate &&
      name &&
      jwtDecodeToken.roleId !== 4) ||
    getToggleSettingsLoading
  ) {
    return <Loader />;
  }

  // subscription checking
  if (!checkInSubscription('campaigner') && path === '/campaigner') {
    return <NotFound />;
  }

  if (!checkInSubscription('messaging') && path === '/communication') {
    return <NotFound />;
  }
  return (
    <>
      <Route
        {...rest}
        component={Component}
        type={type}
        stripeStatus={stripeStatus}
        isPrivate={isPrivate}
        verifiable={verifiable}
        isAuth={isAuth}
        path={path}
        location={location}
      />
    </>
  );
}

RouteWrapper.defaultProps = {
  isPrivate: false,
  stripeStatus: '',
  isAuth: false,
  type: 'dashboard',
};
